module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "contact-us"
  }, [_c('ul', [_c('li', {
    staticClass: "contact-qq"
  }, [_c('p', {
    staticClass: "contact-us-icon qq"
  }), _vm._v(" "), _c('div', {
    staticClass: "qq-panel Panel"
  }, [_c('div', {
    staticClass: "qq-list"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://p.qiao.baidu.com/cps/chat?siteId=10090048&userId=22278208",
      "alt": "在线咨询",
      "title": "在线咨询"
    }
  }, [_c('div', {
    staticClass: "contact-qq-icon"
  }), _vm._v(" "), _c('p', {
    staticClass: "dt-f12"
  }, [_vm._v("在线咨询")])]), _vm._v(" "), _c('a', {
    staticClass: "contact-tel-a",
    attrs: {
      "target": "_blank",
      "href": "tel:15201338330"
    }
  }, [_c('div', {
    staticClass: "contact-tel-icon"
  }), _vm._v(" "), _c('p', {
    staticClass: "dt-f12"
  }, [_vm._v("15201338330")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "contact-email"
  }, [_c('p', {
    staticClass: "contact-us-icon email"
  }), _vm._v(" "), _c('div', {
    staticClass: "email-panel Panel"
  }, [_c('div', {
    staticClass: "email-list"
  }, [_c('a', {
    attrs: {
      "href": "mailto:bd@leador.com.cn"
    }
  }, [_c('div', {
    staticClass: "contact-email-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "contact-email-text"
  }, [_c('p', {
    staticClass: "dt-f14 contact-us-header"
  }, [_vm._v("商务合作")]), _vm._v(" "), _c('p', {
    staticClass: "dt-f12 mailName"
  }, [_vm._v("bd@leador.com.cn")])])])])])]), _vm._v(" "), _c('li', {
    staticClass: "contact-rqcode hidden-xs"
  }, [_c('p', {
    staticClass: "contact-us-icon rqcode"
  }), _vm._v(" "), _c('div', {
    staticClass: "rqcode-panel Panel"
  }, [_c('div', {
    staticClass: "rqcode-list"
  }, [_c('p', {
    staticClass: "scan"
  }, [_vm._v("【扫一扫】立即关注")]), _vm._v(" "), _c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "contact-rqcode-icon wechat"
  }), _vm._v(" "), _c('p', {
    staticClass: "dt-mar8t color66 dt-f12"
  }, [_vm._v("微信公众号")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticClass: "contact-rqcode-icon sina"
  }), _vm._v(" "), _c('p', {
    staticClass: "dt-mar8t color66 dt-f12"
  }, [_vm._v("新浪微博")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0213bd44","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contactUs.vue
// module id = 134
// module chunks = 1